export const CardDataStructure = [
  {
    image:
      "https://images.ctfassets.net/ooa29xqb8tix/3Z0mw6Dz4U5Ur4wzXB0dAB/e2df8ffe8423497808f3a5c4ab3c8d5e/Flutter_Part_2_200x150_cover.svg",
    title: "Getting started with Veu CSS",
    subtitle: "Documentation",
  },
  {
    image:
      "https://images.ctfassets.net/ooa29xqb8tix/7AKHTxONoit7HTh10CqS4v/d37301dbb1e63349cd870ec662577547/ui-design_200x150_cover_new.svg",
    title: "Resources Logo, Icons...",
    subtitle: "Documentation",
  },
  {
    image:
      "https://images.ctfassets.net/ooa29xqb8tix/3huKw3rdJ5Rw7S28xUVd03/648ef62bed4d9699f8c960ae606c501e/swiftui14_200x150_cover_new.svg",
    title: "Veu CSS UI Components",
    subtitle: "Website",
  },
  {
    image:
      "https://images.ctfassets.net/ooa29xqb8tix/vax5GJOwUvyZpy5HK5E4V/218cab959ccf434bca628e117501ebdc/react-native_part_1_200x150_cover_new.svg",
    title: "Veu CSS Social Networks",
    subtitle: "Documentation",
  },
  {
    image:
      "https://images.ctfassets.net/ooa29xqb8tix/5IlJUXNvO9iGDf1zXdTYsE/fc4007940042e84f34f7fa8137634eff/ProtoPie_200x150_cover_new.svg",
    title: "What's new Veu CSS",
    subtitle: "Documentation",
  },
]
